export { SETTINGS_HOME } from './settings'

export const ABOUT = 'ABOUT'
export const ACCOUNT = 'ACCOUNT'
export const AUTHENTICATION = 'AUTHENTICATION'
export const CHAT_COMMANDS = 'CHAT_COMMANDS'
export const ERROR = 'ERROR'
export const FIND_PINNED_ROOMS = 'FIND_PINNED_ROOMS'
export const FRIEND_CONFIRMATION = 'FRIEND_CONFIRMATION'
export const HIDDEN_MODELS = 'HIDDEN_MODELS'
export const IGNORED_MODELS = 'IGNORED_MODELS'
export const LOUNGE_AUTOPLAY_OPTIONS = 'LOUNGE_AUTOPLAY_OPTIONS'
export const LOUNGES = 'LOUNGES'
export const MAIL_MESSAGE = 'MAIL_MESSAGE'
export const SEND_MAIL_MESSAGE = 'SEND_MAIL_MESSAGE'
export const MODEL_NOTIFICATIONS = 'MODEL_NOTIFICATIONS'
export const MODELS_YOU_MAY_LIKE_POOL = 'MODELS_YOU_MAY_LIKE_POOL'
export const MY_ACCOUNT = 'MY_ACCOUNT'
export const NEWS_CHAT_NOTIFICATIONS = 'NEWS_CHAT_NOTIFICATIONS'
export const NEWS_MANAGE_FOLLOWERS_LIST = 'NEWS_MANAGE_FOLLOWERS_LIST'
export const NEWS_MANAGE_FOLLOWING_LIST = 'NEWS_MANAGE_FOLLOWING_LIST'
export const NEWS_MANAGE_IGNORED_LIST = 'NEWS_MANAGE_IGNORED_LIST'
export const NEWS_POST = 'NEWS_POST'
export const NOTES = 'NOTES'
export const PARTICIPANTS = 'PARTICIPANTS'
export const PM_PRIVACY_OPTIONS = 'PM_PRIVACY_OPTIONS'
export const PROFILE = 'PROFILE'
export const REPORT_USER = 'REPORT_USER'
export const SHARE_THING = 'SHARE_THING'
export const SIGNUP = 'SIGNUP'
export const SUPPORT = 'SUPPORT'
export const TIPS = 'TIPS'
export const TIPS_SHARE = 'TIPS_SHARE'
export const TOKEN_STATS = 'TOKEN_STATS'
export const TOKENS = 'TOKENS'
export const TOPIC = 'TOPIC'
export const USER_FEEDBACK = 'USER_FEEDBACK'
export const WHITEBOARD = 'WHITEBOARD'
